import { pushInfoToGa } from "./utils";

class BannerAnalyticService {
  pushStormlyBannerClick = (banner, variant, customerId) => {
    //@ts-ignore
    const stormlyAnalitic = window?.analytics;
    const requestObj = {
      event: "stormlyImpressionClick",
      ...banner,
      platform: "WEB"
    };
    this.pushIdentifyDataToStormly(variant, customerId);

    stormlyAnalitic.track("click", requestObj);
  };

  pushStormlyBannerImpressions = (banner, variant, customerId) => {
    //@ts-ignore
    const stormlyAnalitic = window?.analytics;

    const requestObj = {
      event: "stormlyImpressions",
      ...banner,
      platform: "WEB"
    };

    this.pushIdentifyDataToStormly(variant, customerId);

    stormlyAnalitic.track("scroll", requestObj);
  };

  pushIdentifyDataToStormly = (variant, customerId) => {
    //@ts-ignore
    const stormlyAnalitic = window?.analytics;

    if (customerId) {
      stormlyAnalitic.identify(customerId.toString(), {
        experiments: { "user-variant": variant }
      });
    } else {
      stormlyAnalitic.identify({ experiments: { "user-variant": variant } });
    }
  };
}

export default BannerAnalyticService;
